<template>
  <div class="ma-4 app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeletonForm" class="pa-3">
      <v-row>
        <v-col v-for="n in 3" :key="`line_form_2_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
    </v-sheet>

    <v-form v-show="!showSkeletonForm">
      <v-row dense>
        <v-col>

          <CalendarWithMultipleAndRange
            label="Dias"
            v-model="dateSelected"
            :date-props="dateProps"
            :text-field-props="textProps"
          />
        </v-col>

        <v-col>

        
          <ClockRange
            min_max="true"
            label="Horas"
            v-model="timeSelected"
            :time-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
          />
        </v-col>
        <v-col>
          <v-autocomplete
            v-model="form.filas"
            :items="queues"
            outlined
            multiple
            dense
            label="Filas"
            :error-messages="filasErrors"
            @input="$v.form.filas.$touch()"
            @blur="$v.form.filas.$touch()"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.filas.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="form.filas.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
           <v-col>
          <v-text-field
            :value="maiorQue"
            @change="v => (maiorQue = v)"
            dense
            outlined
            label="Duração maior que"
            hint="hh:mm:ss"
            v-mask="['##:##:##', '##:##','##']"
            persistent-hint
            @input="$v.maiorQue.$touch()"
            :error-messages="maiorQueErrors"
          />
        </v-col>
         <v-col>
          <v-text-field
            :value="menorQue"
            @change="v => (menorQue = v)"
            dense
            outlined
            label="Duração menor que"
            hint="hh:mm:ss"
            v-mask="['##:##:##', '##:##','##']"
            persistent-hint
            @input="$v.menorQue.$touch()"
            :error-messages="menorQueErrors"
          />
        </v-col>
        <v-col>          
          <v-autocomplete
            multiple
            dense
            outlined
            label="Centro de Custos"
            v-model="form.centrosDeCusto"
            :items="centrosDeCusto"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.centrosDeCusto.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleCentroDeCustos">
                <v-list-item-action>
                  <v-icon :color="form.centrosDeCusto.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconCentroDeCusto }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col class="text-right">
          <v-btn color="orangePcm" dark class="mr-2" @click="exportExcel">Exportar Excel</v-btn>
          <v-btn dark color="bluePcm" @click="gerar">Gerar</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="ma-2" />
    <v-sheet class="px-3 pt-3 pb-3" v-show="showSkeleton">
      <v-skeleton-loader class="mx-auto" type="button" />
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="showRelatorios">
      <div v-show="!showSkeleton">
        <v-row v-show="respostaVazia">
          <v-col>
            <div class="text-h5">
              Não há informações com os filtros selecionados.
            </div>
          </v-col>
        </v-row>
        <div v-show="!respostaVazia" >
          <v-row justify="space-around" class="my-8">
            <CardAverage
              cardTitle="TMC"
              :cardTime="tempoMedioChamada"
              tip="Tempo Médio de Chamada"
            />

            <CardAverage
              cardTitle="TMA"
              :cardTime="tempoMedioAtendimento"
              tip="Tempo Médio de Atendimento"
            />

            <CardAverage
              cardTitle="TME"
              :cardTime="tempoMedioEspera"
              tip="Tempo Médio de Espera"
            />

            <CardAverage
              cardTitle="TMAB"
              :cardTime="tempoMedioAbandono"
              tip="Tempo Médio de Abandono"
            />

            <CardAverage
              v-show="cardNivelServico"
              :cardTime="cardNivelServico"
              cardTitle="Nível de Serviço"
              tip="Nível de Serviço"
            />
          </v-row>

          <v-row justify="center" align="center">
            <v-col cols="3">
              <CardResume
                color="lightBlue"
                avatarColor="blue"
                icon="mdi-alarm mdi-48px"
                progressValue="100"
                :info="cardTotal"
                class="mr-2 mb-2"
                title="Total de Ligações"
              />
              <CardResume
                color="yellow"
                avatarColor="darkYellow"
                icon="mdi-alert-octagon mdi-48px"
                :info="cardTimeout"
                :progressValue="progressValueTimeout"
                class="mr-2"
                title="Transbordo"
              />
            </v-col>
            <v-col cols="3">
              <CardResume
                color="lightGreen"
                avatarColor="green"
                icon="mdi-check-decagram mdi-48px"
                :info="cardAtendidas"
                :progressValue="progressValueAtendidas"
                class="mr-2 mb-2"
                title="Atendidas"
              />
              <CardResume
                color="lightRed"
                avatarColor="red"
                icon="mdi-close-octagon mdi-48px"
                :info="cardAbandonadas"
                :progressValue="progressValueAbandonadas"
                class="mr-2"
                title="Abandonadas"
              />
            </v-col>
            <v-col cols="4">
              <DonutChart :valores="series" />
            </v-col>
          </v-row>
          <v-row class="mx-n5">
            <v-col>
              <LineChart
                :dataLine="dataLinePorHora"
                :optionsLine="optionsLinePorHora"
                graphKey = "graficoPorHora" 
              />
            </v-col>
          </v-row>
          <v-row class="mx-n5">
            <v-col>
              <LineChart
                :dataLine="dataLineTmPorHora"
                :optionsLine="optionsLineTmcPorHora"
                graphKey = "graficoTmcPorHora" 
              />
            </v-col>
          </v-row>
          <v-row class="mx-n5">
            <v-col>
              <LineChart
                :dataLine="dataLinePorDia"
                :optionsLine="optionsLinePorDia"
                graphKey = "graficoPorDia" 
              />
            </v-col>
          </v-row>
          <v-row class="mx-n5">
            <v-col>
              <LineChart
                :dataLine="dataLineTmPorDia"
                :optionsLine="optionsLineTmcPorDia"
                graphKey = "graficoTmcPorDia" 
                @uri = 'gerarPDFTotal'
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-h5 font-weight-bold">
                Informações Ligações por Hora
              </div>
              <v-data-iterator
                :no-data-text="noDataText"
                :items="itemsHora"
                :items-per-page.sync="itemsPerPage"
                :page="pagePorHora"
                :search="searchTabelaHora"
                :no-results-text="noResultsText"
                hide-default-footer
              >
                <template v-slot:header>
                  <v-row justify="end">
                    <v-col cols="4">
                      <v-text-field
                        v-model="searchTabelaHora"
                        clearable
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        label="Busca"
                      />
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:default="props">
                  <v-data-table
                    dense
                    :headers="headersHora"
                    :items="props.items"
                    hide-default-footer
                    class="elevation-1"
                    disable-pagination
                    disable-sort
                  />
                </template>

                <template v-slot:footer>
                  <v-row class="mt-2" align="center" justify="center">
                    <div class="ml-4 mb-2 grey--text">
                      <p>Total de Registros: {{ qtdRegistrosHora }}</p>
                    </div>
                    <v-spacer />
                    <div class="pb-5">
                      <ListPagination
                        :page="pagePorHora"
                        :numberOfPages="numberOfPagesHora"
                        @firstPage="firstPage('hora')"
                        @formerPage="formerPage('hora')"
                        @nextPage="nextPage('hora')"
                        @lastPage="lastPage('hora')"
                      />
                    </div>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-h5 font-weight-bold">
                Informações Ligações por Dia
              </div>
              <v-data-iterator
                :no-data-text="noDataText"
                :items="itemsDia"
                :items-per-page.sync="itemsPerPage"
                :page="pagePorDia"
                :search="searchTabelaDia"
                :no-results-text="noResultsText"
                hide-default-footer
              >
                <template v-slot:header>
                  <v-row justify="end">
                    <v-col cols="4">
                      <v-text-field
                        v-model="searchTabelaDia"
                        clearable
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        label="Busca"
                      />
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:default="props">
                  <v-data-table
                    dense
                    :headers="headersDia"
                    :items="props.items"
                    hide-default-footer
                    class="elevation-1"
                    disable-pagination
                    disable-sort
                  />
                </template>

                <template v-slot:footer>
                  <v-row class="mt-2" align="center" justify="center">
                    <div class="ml-4 mb-2 grey--text">
                      <p>Total de Registros: {{ qtdRegistrosDia }}</p>
                    </div>
                    <v-spacer />
                    <div clas="pb-5">
                      <ListPagination
                        :page="pagePorDia"
                        :numberOfPages="numberOfPagesDia"
                        @firstPage="firstPage('dia')"
                        @formerPage="formerPage('dia')"
                        @nextPage="nextPage('dia')"
                        @lastPage="lastPage('dia')"
                      />
                    </div>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import moment from "moment";
import Snackbar from '@/componentes/Snackbar'
import relatorioSinteticoHttpService from "../_services/relatorioSinteticoHttpService"

import ListPagination from "@/componentes/ListPagination";
import CalendarWithMultipleAndRange from "@/componentes/CalendarWithMultipleAndRange";
import ClockRange from "@/componentes/ClockRange";

import { registerVuexModule } from "@/utils/vuexUtils";
import { initialAndFinalDateTextInputReportForm } from "@/mixins/initialAndFinalDateTextInputReportForm";

import CardResume from "../../../../../components/CardResume";
import CardAverage from "../../../../../components/CardAverage";
import DonutChart from "../../../../../components/DonutChart";
import LineChart from "../../../../../components/LineChart";

import { relatoriosFilasMixins } from "../../../_mixins/relatoriosFilasMixins";

import relatorioSinteticoFilaStore from "../_store";
import { relatorioSinteticoUtils } from "../_utils/relatorioSinteticoUtils";
import { tabelasRelatorioFilaMethods } from "../_utils/tabelasRelatorioFilaMethods";
import { graficosRelatorioFilaMethods } from "../_utils/graficosRelatorioFilaMethods";
import { validateData, validateComputed } from "../_validates";
import {mask} from 'vue-the-mask';
import relatoriosStore from '../../../../../store';
import moment from 'moment';

export default {
  components: {
    CardResume,
    DonutChart,
    LineChart,
    CardAverage,
    ListPagination,
    CalendarWithMultipleAndRange,
    ClockRange,
    Snackbar,
  },
  mixins: [initialAndFinalDateTextInputReportForm, relatoriosFilasMixins],
  directives: {mask},

  data: () => ({
    panel: [],
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    searchTabelaHora: "",
    pagePorHora: 1,

    searchTabelaDia: "",
    pagePorDia: 1,

    itemsPerPage: 20,
    headersHora: [
      { text: "Data", value: "data", align: "left" },
      { text: "Hora", value: "hora", align: "left" },
      { text: "Total", value: "total", align: "right" },
      { text: "Atendidas", value: "atendidas", align: "left" },
      { text: "Abandonadas", value: "abandonadas", align: "left" },
      { text: "Transbordo", value: "transbordo", align: "left" },
      { text: "TMC", value: "tmc", align: "left" },
      { text: "TMA", value: "tma", align: "left" },
      { text: "TME", value: "tme", align: "left" },
      { text: "TMAB", value: "tmab", align: "left" },
    ],
    headersDia: [
      { text: "Data", value: "data", align: "left" },
      { text: "Total", value: "total", align: "right" },
      { text: "Atendidas", value: "atendidas", align: "left" },
      { text: "Abandonadas", value: "abandonadas", align: "left" },
      { text: "Transbordo", value: "transbordo", align: "left" },
      { text: "TMC", value: "tmc", align: "left" },
      { text: "TMA", value: "tma", align: "left" },
      { text: "TME", value: "tme", align: "left" },
      { text: "TMAB", value: "tmab", align: "left" },
    ],
    itemsHora: [],
    itemsDia: [],
    form: {
      filas: [],
      maiorQue: 0,
      menorQue: 0,
      centrosDeCusto: [],
    },
    series: [],
    dataLinePorHora: {
      atendidas: [],
      abandonadas: [],
      transbordo: [],
      name: ["Atendidas", "Abandonadas", "Transbordo"],
    },
    dataLinePorDia: {
      atendidas: [],
      abandonadas: [],
      transbordo: [],
      name: ["Atendidas", "Abandonadas", "Transbordo"],
    },
    dataLineTmPorHora: {
      tmc: [],
      tma: [],
      tme: [],
      tmab: [],
      name: ["TMC", "TMA", "TME", "TMAB"],
    },
    dataLineTmPorDia: {
      tmc: [],
      tma: [],
      tme: [],
      tmab: [],
      name: ["TMC", "TMA", "TME", "TMAB"],
    },
    optionsLinePorHora: {},
    optionsLinePorDia: {},
    optionsLineTmcPorHora: {},
    optionsLineTmcPorDia: {},
    tempoMedioChamada: "",
    tempoMedioAtendimento: "",
    tempoMedioEspera: "",
    tempoMedioAbandono: "",
    cardTotal: "",
    cardAbandonadas: "",
    cardTimeout: "",
    cardAtendidas: "",
    cardNivelServico: "",
    progressValueAtendidas: "",
    progressValueTimeout: "",
    progressValueAbandonadas: "",
    progressValueNivelServico: "",
    showRelatorios: false,
    respostaVazia: false,
    maiorQue:'',
    menorQue:'',
    centrosDeCusto: [],
    dateSelected:{},
    timeSelected:{},
    snackbar:false,
    text:'',
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('relatoriosFilaStore', ['getCentrosDeCusto']),
    ...mapGetters("relatorioSinteticoFilaStore", ["getDadosRelatorio"]),
    ...validateComputed,
    numberOfPagesHora() {
      return Math.ceil(this.itemsHora.length / this.itemsPerPage);
    },
    qtdRegistrosHora() {
      return this.itemsHora.length;
    },
    numberOfPagesDia() {
      return Math.ceil(this.itemsDia.length / this.itemsPerPage);
    },
    qtdRegistrosDia() {
      return this.itemsDia.length;
    },
    todosCentrosDeCustosSelecionados() {
      return this.form.centrosDeCusto.length === this.centrosDeCusto.length
    },
    algunsCentrosDeCustosSelecionados() {
      return this.form.centrosDeCusto.length > 0 && !this.todosCentrosDeCustosSelecionados
    },
    iconCentroDeCusto() {
      if (this.todosCentrosDeCustosSelecionados) return 'mdi-close-box'
      if (this.algunsCentrosDeCustosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    dateTimeRange(){
      return {...this.dateSelected,...this.timeSelected}
    }
  },

  async created() {
    this.showSkeletonForm = true;

    registerVuexModule(this.$store, 'relatoriosFilaStore', relatoriosStore)
    await this.buscarCentroDeCustosNaApi()
    registerVuexModule(
      this.$store,
      "relatorioSinteticoFilaStore",
      relatorioSinteticoFilaStore
    );

    await this.buscarFilas();
    this.queues = this.getQueues.map((fila) => ({
      text: fila.description,
      value: fila._id,
    }));
    this.menorQue ="00:00:00"
    this.maiorQue ="00:00:00"

    this.timeSelected = {timeStart: '00:00', timeEnd: '23:59'}
    this.dateSelected = {dateIsRange: true, dates:[moment().format("YYYY-MM-DD")]}


    this.centrosDeCusto = this.getCentrosDeCusto.map(centroDeCusto => ({
      text: `${centroDeCusto.codigo} - ${centroDeCusto.description}`,
      value: centroDeCusto.codigo,
    }))

    this.showSkeletonForm = false;
  },

  methods: {
    ...mapActions('relatoriosFilaStore', ['buscarCentroDeCustosNaApi']),
    ...mapActions("relatorioSinteticoFilaStore", ["obterDadosRelatorio"]),
    ...relatorioSinteticoUtils,
    ...tabelasRelatorioFilaMethods,
    ...graficosRelatorioFilaMethods,
    gerarPDFTotal(event, teste){ 
      console.log(event, teste, "evento")
    },

    toggleCentroDeCustos() {
      this.$nextTick(() => {
        if (this.todosCentrosDeCustosSelecionados) {
          this.form.centrosDeCusto.splice(0);
        } else {
          this.form.centrosDeCusto.splice(0);
          this.form.centrosDeCusto = this.centrosDeCusto.map(
            (centroDeCusto) => centroDeCusto.value
          );
        }
      });
    },
    

    async exportExcel() {
      const params = {
        dateTimeRange: this.dateTimeRange,
        filas: this.form.filas,
        maiorQue: this.form.maiorQue,
        menorQue: this.form.menorQue,
        centrosDeCusto: this.form.centrosDeCusto,
      }
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }else{
        window.open(relatorioSinteticoHttpService.exportExcel(params))
      }
    },
  },
  watch: {
    maiorQue(novo) {
      this.form.maiorQue = this.maiorQueFormer(novo)
    },
    menorQue(novo) {
      this.form.menorQue = this.menorQueFormer(novo)
    },

  },
};
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}

.divider {
  width: 220px;
}
</style>
